const ALLOWED_DOC_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];

const ALLOWED_DOC_EXTENSIONS = ['.pdf', '.doc', '.docx'];

const MAX_DOC_SIZE = 10 * 1024 * 1024; // 10MB

export const validateDocumentType = (file) => {
  const extension = '.' + file.name.split('.').pop().toLowerCase();
  const typeValid = ALLOWED_DOC_TYPES.includes(file.type);
  const extValid = ALLOWED_DOC_EXTENSIONS.includes(extension);
  // Check both because some browsers don't set MIME type correctly for .doc/.docx
  return typeValid || extValid;
};

export const validateDocumentSize = (file) => {
  return file.size <= MAX_DOC_SIZE;
};

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

export const getDocumentIcon = (fileName) => {
  const ext = fileName.split('.').pop().toLowerCase();
  switch (ext) {
    case 'pdf': return '📄';
    case 'doc':
    case 'docx': return '📝';
    default: return '📎';
  }
};
